import React from 'react'
import { connect } from 'react-redux'

import './../item-currency/item-currency.css'

class TotalMutacao extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      dados: this.props.dados.datas,
      total: this.props.mutacao.total
    }

    this.props.mutacao.total =
      this.props.mutacao.total === undefined ||
      this.props.mutacao.total.length === 0
        ? new Array(this.props.dados.datas.length).fill(0)
        : this.props.mutacao.total
  }

  render () {
    const { dados, mutacao } = this.props

    const getDate = date => {
      const d = new Date(date)
      return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear()
    }

    return (
      <div className='ativoTotal'>
        <div className='row justify-content-center no-gutters'>
          <div className='col-10'>
            <div className='row justify-content-start'>
              <div className='col-auto row justify-content-start'>
                <div className='total-txt col-auto text-right'>Total</div>
                {dados.datas.map((date, keyData) => (
                  <div className='col-auto total-bloc' key={keyData}>
                    <div className='total-date'>{getDate(date.data)}</div>
                    <div className='total-secondLine'>
                      <span>R$</span>
                      <span>
                        {mutacao.items &&
                          mutacao.items.total &&
                          mutacao.items.total.length > 0 &&
                          mutacao.items.total[keyData] &&
                          mutacao.items.total[keyData].toLocaleString('pt-BR')}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dados: state.dados,
  ativo: state.ativo,
  mutacao: state.mutacao
})

export default connect(mapStateToProps)(TotalMutacao)
